import { motion } from "framer-motion";
import { BadgeCheck } from "lucide-react";

const ABOUT_IMG = "/contador.png";

const CREDENCIALES = [
    "Contador Público",
    "Especialista en Gerencia Tributaria y Auditoría de Impuestos",
    "Especialista en Revisoría Fiscal",
    "Especialista en Finanzas",
    "Diplomado en NIIF para PYMES",
    "Diplomado en Comercio Exterior",
    "Más de 10 años de experiencia",
];

export default function Nosotros() {
    return (
        <section id="nosotros" className="relative bg-[#F8F9FA] px-6 py-24 text-navy md:px-12 md:py-36" data-testid="nosotros-section">
            <div className="mx-auto max-w-[1440px]">
                <div className="mb-16 md:mb-24">
                    <motion.p
                        initial={{ opacity: 0, y: 16 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true, margin: "-80px" }}
                        transition={{ duration: 0.7 }}
                        className="mb-6 text-[11px] uppercase tracking-[0.3em] text-gold-dim"
                        data-testid="nosotros-overline"
                    >
                        Capítulo 02 — Nosotros
                    </motion.p>
                    <motion.h2
                        initial={{ opacity: 0, y: 24 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true, margin: "-80px" }}
                        transition={{ duration: 0.8, delay: 0.1 }}
                        className="max-w-3xl font-display text-4xl font-medium leading-[1.05] tracking-tighter sm:text-5xl lg:text-6xl"
                        data-testid="nosotros-heading"
                    >
                        Una firma, un contador, un compromiso con tu empresa.
                    </motion.h2>
                </div>

                <div className="grid grid-cols-1 gap-16 lg:grid-cols-2 lg:gap-24">
                    <motion.div
                        initial={{ opacity: 0, y: 32 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true, margin: "-80px" }}
                        transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
                        className="flex flex-col justify-between"
                    >
                        <div className="space-y-6 text-base leading-relaxed text-navy/70 md:text-lg" data-testid="nosotros-copy">
                            <p>
                                <span className="font-semibold text-navy">AS Consulting S.A.S.</span> es una
                                firma contable con sede en Cali, dedicada exclusivamente al
                                acompañamiento de pequeñas y medianas empresas en Colombia.
                            </p>
                            <p>
                                Creemos que la contabilidad no es un trámite: es la brújula
                                financiera de tu negocio. Por eso combinamos rigor técnico,
                                actualización normativa permanente y un trato directo, sin
                                intermediarios.
                            </p>
                            <p>
                                Cada cliente habla directamente con el contador a cargo de su
                                proceso. Así de simple, así de serio.
                            </p>
                        </div>

                        <ul className="mt-12 space-y-4" data-testid="nosotros-credenciales">
                            {CREDENCIALES.map((c) => (
                                <li key={c} className="flex items-center gap-4 border-t border-navy/10 pt-4">
                                    <BadgeCheck size={20} className="shrink-0 text-gold-dim" />
                                    <span className="text-sm font-medium uppercase tracking-[0.12em] text-navy/80">{c}</span>
                                </li>
                            ))}
                        </ul>
                    </motion.div>

                    <motion.div
                        initial={{ opacity: 0, y: 32 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true, margin: "-80px" }}
                        transition={{ duration: 0.8, delay: 0.15, ease: [0.16, 1, 0.3, 1] }}
                        className="relative"
                    >
                        <div className="absolute -right-4 -top-4 h-full w-full border border-gold/50" aria-hidden="true" />
                        <div className="relative overflow-hidden">
                            <img
                                src={ABOUT_IMG}
                                alt="CPC Andrés Felipe Solano Muñoz, socio director de AS Consulting S.A.S."
                                className="aspect-[4/5] w-full object-cover"
                                loading="lazy"
                                data-testid="nosotros-image"
                            />
                        </div>
                        <div className="relative z-10 -mt-20 ml-6 max-w-sm bg-navy p-8 text-[#F8F9FA] md:ml-10" data-testid="contador-card">
                            <p className="mb-1 text-[10px] uppercase tracking-[0.3em] text-gold">Socio director</p>
                            <p className="font-display text-2xl font-medium tracking-tight">CPC Andrés Felipe Solano Muñoz</p>
                            <p className="mt-3 text-sm leading-relaxed text-[#9CA3AF]">
                                Contador Público, especialista en gerencia tributaria,
                                revisoría fiscal y finanzas, con diplomados en NIIF para
                                PYMES y comercio exterior. Consultor de empresas del
                                suroccidente colombiano.
                            </p>
                        </div>
                    </motion.div>
                </div>
            </div>
        </section>
    );
}
